import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);
import index from '@/app/common/index/index.vue'
import download from '@/app/common/download/index.vue'
import expense from '@/app/common/expense/app-expense.vue'
import downloadDdetail from '@/app/common/download-detail/index.vue'

export default new VueRouter({
    linkActiveClass: 'link-active',
    mode: 'hash',
    // mode:'history',
    // scrollBehavior (to,from, savedPosition)
    scrollBehavior(to) {
        if (to.hash) {
            return {
                selector: to.hash
            }
        }
        return {
            x: 0,
            y: 0
        };
    },
    routes: [
        // { path: '/', redirect: '/home' },
        { path: '/', component: index },
        { path: '/download', component: download },
        { path: '/expense', component: expense },
        { path: '/detail', name: 'detail', component: downloadDdetail },
        { path: '*', component: index }
    ]
})